import { combineReducers } from "redux";
import FixedClock from "../lib/FixedClock";

//FIXME: Is it weird and wrong to have the "logout" action touch many keys like this?

function userReducer(user_state = {}, action) {
	var new_user_state;
	switch (action.type) {
		case "CHANGE_USER":
			new_user_state = { ...user_state };
			new_user_state[action.name] = action.new_value;
			return new_user_state;
		case "LOGOUT":
			return { nick_name: "", room_key: "", view_mode: "full", ideal_position: 0 };
		default:
			return user_state;
	}
}

function roomReducer(room_state = {}, action) {
	var new_room_state;
	switch (action.type) {
		case "SET_ROOM":
			new_room_state = {
				video_url: action.video_url,
				subtitle_url: action.subtitle_url,
				is_playing: action.is_playing,
				video_position: action.video_position,
				video_position_timestamp: action.video_position_timestamp,
				video_length: action.video_length,
				password: action.password
			};
			return new_room_state;
		case "LOGOUT":
			return { video_url: "", is_playing: false, last_pos: 0, last_pos_timestamp: 0, password: null };
		default:
			return room_state;
	}
}

function chatsReducer(chat_state = {}, action) {
	let new_chat = {};
	switch (action.type) {
		case "ADD_CHAT":
			new_chat = { nick_name: action.nick_name, message: action.message, timestamp: FixedClock.utc() };
			return [...chat_state, new_chat];
		case "LOGOUT":
			return [];
		default:
			return chat_state;
	}
}

function presentReducer(present_state = {}, action) {
	switch (action.type) {
		case "PRESENCE_JOIN":
			return [...present_state, action.presence];
		case "PRESENCE_LEAVE":
			return present_state.filter(item => (item.connection_id !== action.connection_id));
		case "LOGOUT":
			return [];
		default:
			return present_state;
	}
}

export const rootReducer = combineReducers({
	user: userReducer,
	room: roomReducer,
	chats: chatsReducer,
	present: presentReducer
});

// export type RootState = ReturnType<typeof rootReducer>
